const toggleCollapse = (e) => {
  let currentElWrap = e.target.closest("td");
  if (currentElWrap.classList.contains("collapsable")) {
    currentElWrap.classList.remove("collapsable");
  } else {
    currentElWrap.classList.add("collapsable");
    currentElWrap.scrollIntoView({ behavior: "smooth" });
  }
};

export const renderCollapseBtn = () => {
  let btn = document.createElement("div");
  btn.setAttribute("class", "collapsable__btn");
  btn.innerHTML = `<span>Показать</span><span>Скрыть</span>`;
  btn.addEventListener("click", toggleCollapse);
  return btn;
};
